import axios from "axios";

export const API = "/api";

export const api = axios.create({ baseURL: API, timeout: 120000 });

// Attach admin token (if present) to every request
api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("apib_admin_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

// On 401 to admin endpoints, clear token and redirect to /admin/login
api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        if (status === 401 && url.includes("/admin/")) {
            localStorage.removeItem("apib_admin_token");
            if (typeof window !== "undefined" && !window.location.pathname.includes("/admin/login")) {
                window.location.assign("/admin/login");
            }
        }
        return Promise.reject(err);
    }
);

// Public
export const getNodes = () => api.get("/nodes").then(r => r.data);
export const getSdks = () => api.get("/sdks").then(r => r.data);
export const getProducts = () => api.get("/products").then(r => r.data);
export const getMetrics = () => api.get("/metrics/snapshot").then(r => r.data);
export const getHealth = () => api.get("/healthz").then(r => r.data);
export const simulateAgent = (objective, persona = "developer") =>
    api.post("/agent/simulate", { objective, persona }).then(r => r.data);
export const executePlayground = (code, sdk = "python") =>
    api.post("/playground/execute", { code, sdk }).then(r => r.data);
export const createLead = (payload) =>
    api.post("/leads", payload).then(r => r.data);
export const sendTelemetry = (event, meta = {}) => {
    try { return api.post("/telemetry", { event, meta }).then(r => r.data); }
    catch { return Promise.resolve({ ok: false }); }
};

// Admin
export const adminLogin = (email, password) =>
    api.post("/admin/login", { email, password }).then(r => r.data);
export const adminMe = () => api.get("/admin/me").then(r => r.data);
export const adminLogout = () => api.post("/admin/logout").then(r => r.data);
export const adminStats = () => api.get("/admin/stats").then(r => r.data);
export const adminListLeads = (params = {}) =>
    api.get("/admin/leads", { params }).then(r => r.data);
export const adminPatchLead = (id, body) =>
    api.patch(`/admin/leads/${id}`, body).then(r => r.data);
export const adminDeleteLead = (id) =>
    api.delete(`/admin/leads/${id}`).then(r => r.data);
export const adminListSimulations = (limit = 30) =>
    api.get("/admin/simulations", { params: { limit } }).then(r => r.data);
export const adminListTelemetry = (limit = 100) =>
    api.get("/admin/telemetry", { params: { limit } }).then(r => r.data);
export const adminExportLeadsUrl = () => `${API}/admin/leads.csv`;
